




























































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import axios, { resHandle } from "@/plugins/axios";
import * as _ from "lodash";
import {
  GetTopicsOfTemplate,
  GetTemplatesOfGroup,
  GetImportWayCenterList,
} from "@/request/projects";
import { GetUserHospitals } from "@/request/hospitals";
import { GetPatientsList, GetHospitals } from "@/request/edr";
import { PostImportHospatients } from "@/request/groups";
import Pagination from "@/components/paginaiton.vue";
import Copy from "@/components/copy.vue";
import AddPatient from "./add-patient.vue";
import SelectMultiSearch from "./select-multi-search.vue";
@Component({
  components: {
    Copy,
    Pagination,
    AddPatient,
    SelectMultiSearch,
  },
})
export default class SizhenPatients extends Vue {
  private project: any = {};
  private groupId: any = "";
  // 搜索条件
  private hospitals: any[] = [];
  private saveModel: "add" | "delete" = "add";
  private filters: any = {
    hospital_ids: [],
    范围: [],
    search: "",
    性别: "",
    开始年龄: "",
    结束年龄: "",
    开始时间: "",
    结束时间: "",
    年龄段: [],
    timeWay: "",
    time: [],
    条件: "",
    研究指标: [],
    自定义年龄: [false],
    时间段: "",
    自定义时间段: [false, []],
  };
  // 排序
  private cSortField: string = "更新时间";
  private cSortValue: string = "0";
  // 选择
  private isIndeterminate: boolean = false;
  private checkAll: boolean = false;
  private selectedMessages: any[] = [];
  // 翻页
  private ifLoading: boolean = false;
  private currentPage: any = 1;
  private totalPage: any = 0;
  private totalCount: any = 0;
  private pageSize: any = 10;
  // 列表
  private patients: any[] = [];
  // 添加患者
  private ifShowAddPatient: boolean = false;
  private cPatient: any = {};
  // 高级筛选
  private ifShowPrimarySearch: boolean = false;
  private searchedTemplates: any[] = [];
  private ifPrimarySearched: boolean = false;
  private projectChange() {
    this.$emit("update:project", this.project);
  }
  /**
   * @description 获得可选医院列表
   */
  private fetchHospitals() {
    const params: any = {
      params: {
        project_id: this.$route.query.project_id,
      },
    };
    GetHospitals(this, params).then((data: any) => {
      this.hospitals = data;
      this.hospitals.unshift({ hospital_id: "", 医院名称: "全部医院" });
    });
  }
  /**
   * @description 添加档案
   */
  private addPatient() {
    this.ifShowAddPatient = true;
  }
  /**
   * @description 打开高级筛选
   */
  private openPrimarySearch() {
    this.fetchTemplates();
    this.ifShowPrimarySearch = true;
  }
  /**
   * @description 添加研究指标变量
   */
  private addTiaojian() {
    this.filters["研究指标"].push({ result: {}, selected: {} });
  }
  /**
   * @description 获取当前分组下的可选模板列表
   */
  private fetchTemplates() {
    GetTemplatesOfGroup(this, this.project.project_id, this.groupId).then(
      (data: any) => {
        this.searchedTemplates = data;
      }
    );
  }
  /**
   * @description 搜索模板下具体的字段
   */
  private searchItems(l) {
    GetTopicsOfTemplate(this, l.template_id).then((data: any) => {
      l.items = data;
      this.$forceUpdate();
    });
  }
  /**
   * @description 删除一个条件
   */
  private deleteTiaojian(index: any) {
    this.filters["研究指标"].splice(index, 1);
  }
  /**
   * @description 重置高级搜索
   */
  private resetPrimarySearch() {
    this.ifPrimarySearched = false;
    this.ifShowPrimarySearch = false;
    this.filters.timeWay = "";
    this.filters.time = [];
    this.filters["条件"] = "";
    this.filters["研究指标"] = [];
    this.search();
  }
  /**
   * @description 取消高级筛选
   */
  private cancelPrimarySearch() {
    this.ifShowPrimarySearch = false;
  }
  /**
   * @description 确定高级筛选
   */
  private confirmPrimarySearch() {
    this.ifShowPrimarySearch = false;
    this.currentPage = 1;
    this.saveModel = "delete";
    this.ifPrimarySearched = true;
    this.fetchPatients();
  }
  /**
   * @description 跳转数据导出
   */
  private jumpDataExport() {
    if (!this.project.project_id || !this.groupId) {
      return;
    }
    this.$router.push({
      path: "/main/edr/data-export",
      query: {
        group_id: this.groupId,
        project_id: this.project.project_id,
      },
    });
  }
  /**
   * @description 获取病人列表
   */
  private fetchPatients() {
    return new Promise((resolve, reject) => {
      this.ifLoading = true;
      // hospital_ids
      this.filters.hospital_ids = [];
      this.filters["范围"].forEach((item: any) => {
        this.filters.hospital_ids.push(item);
      });
      if (this.filters.hospital_ids.includes("")) {
        this.filters.hospital_ids = [];
      }
      const params: any = {
        category: "名中医传承数据中心",
        hospital_ids: this.filters.hospital_ids,
        project_id: this.project.project_id,
        group_id: this.filters.group_id,
        order_field: this.cSortField,
        order_value: this.cSortValue,
        current_page: this.currentPage,
        page_count: this.pageSize,
        search: this.filters.search,
        性别: this.filters["性别"],
        条件: this.filters["条件"],
      };
      params.project_id = this.$route.query.project_id;
      if (this.filters.timeWay === "自定义") {
        params["开始时间"] = this.filters.time[0];
        params["结束时间"] = this.filters.time[1];
        this.ifPrimarySearched = true;
      }
      if (this.filters["研究指标"].length > 0) {
        this.ifPrimarySearched = true;
        const arr: any[] = [];
        this.filters["研究指标"].map((item: any) => {
          const i = JSON.parse(JSON.stringify(item.selected));
          i.condition = item.result.condition;
          i.value = item.result.value;
          arr.push(i);
        });
        params["研究指标"] = arr;
      }
      GetPatientsList(this, params)
        .then((data: any) => {
          this.patients = data.patients;
          this.totalPage = data.total_page;
          this.totalCount = data.total_count;
          this.project.project_id = data.project_id;
          this.project["项目名称"] = data["项目名称"];
          this.$emit("name", data["项目名称"]);
          this.groupId = data.group_id;
          if (this.saveModel === "add") {
            this.checkAllMessages(false);
            this.autoCheckSelectedMessages(true);
          } else {
            this.checkAllMessages(true);
            this.autoCheckSelectedMessages(false);
          }
          const checkedCount = this.countHowMuchCurrentPageMessagesSelected();
          this.checkAll = checkedCount === this.patients.length;
          this.isIndeterminate =
            checkedCount > 0 && checkedCount < this.patients.length;
          resolve();
        })
        .catch(() => {
          reject();
        })
        .finally(() => {
          this.ifLoading = false;
        });
    });
  }
  /**
   * @description 搜索
   */
  private search() {
    this.currentPage = 1;
    this.saveModel = "delete";
    this.fetchPatients();
  }
  /**
   * @description 处理翻页器的当前页变化
   */
  private handleCurrentPageChange(val) {
    this.currentPage = val;
    this.fetchPatients();
  }
  /**
   * @description 处理排序变化
   */
  private handleSortChange(ev: any) {
    this.cSortField = ev["prop"];
    this.cSortValue = ev["order"] === "ascending" ? "1" : "0";
    this.fetchPatients();
  }
  // 勾选
  /**
   * @description 给所有message勾选上
   */
  private checkAllMessages(isChecked: boolean) {
    this.patients.forEach((message: any, index: number) => {
      this.$set(this.patients[index], "isChecked", isChecked);
    });
    this.isIndeterminate = false;
    this.checkAll = isChecked ? true : false;
  }
  /**
   * @description 增加一个数据到已选列表
   */
  private addOneMessageToSelectedMessages(message: any) {
    this.selectedMessages.push(message);
    this.selectedMessages = _.uniq(this.selectedMessages);
  }
  /**
   * @description 从已选列表中删除一条数据
   */
  private deleteOneMessageFromSelectedMessages(message: any) {
    const index = this.selectedMessages.findIndex(
      (selectedMessage: any) =>
        selectedMessage.patient_id === message.patient_id
    );
    if (index !== -1) {
      this.selectedMessages.splice(index, 1);
    }
  }
  /**
   * @description 增加当前页面所有的消息进入已选列表
   */
  private addAllMessagesToSelectedMessages() {
    this.patients.forEach((message: any) => {
      this.selectedMessages.push(message);
    });
    this.selectedMessages = _.uniq(this.selectedMessages);
  }
  /**
   * @description 将当前页面的所有数据，从已选列表中删除
   */
  private deleteAllMessagesFromSelectedMessages() {
    this.patients.forEach((message: any) => {
      const targetIndex = this.selectedMessages.findIndex(
        (selectedMessage: any) =>
          selectedMessage.patient_id === message.patient_id
      );
      if (targetIndex !== -1) {
        this.selectedMessages.splice(targetIndex, 1);
      }
    });
  }
  /**
   * @description 统计当前页面有多少数据被选中
   */
  private countHowMuchCurrentPageMessagesSelected() {
    let checkedCount = 0;
    this.patients.forEach((message: any) => {
      if (message.isChecked) {
        checkedCount++;
      }
    });
    return checkedCount;
  }
  /**
   * @description 翻页后自动勾选上已经选择的数据
   */
  private autoCheckSelectedMessages(isChecked: boolean) {
    this.patients.forEach((message: any) => {
      const targetIndex = this.selectedMessages.findIndex(
        (selectedMessage: any) =>
          selectedMessage.patient_id === message.patient_id
      );
      if (targetIndex !== -1) {
        message.isChecked = isChecked;
      }
    });
  }
  /**
   * @description 处理点击全选
   */
  private handleCheckAllChange(val) {
    if (val) {
      this.checkAllMessages(true);
      if (this.saveModel === "add") {
        this.addAllMessagesToSelectedMessages();
      } else if (this.saveModel === "delete") {
        this.deleteAllMessagesFromSelectedMessages();
      }
    } else {
      this.checkAllMessages(false);
      if (this.saveModel === "add") {
        this.deleteAllMessagesFromSelectedMessages();
      } else if (this.saveModel === "delete") {
        this.addAllMessagesToSelectedMessages();
      }
    }
  }
  /**
   * @description 处理单个勾选
   */
  private handleCheckedMessageChange(val, item) {
    if (val) {
      if (this.saveModel === "add") {
        this.addOneMessageToSelectedMessages(item);
      } else if (this.saveModel === "delete") {
        this.deleteOneMessageFromSelectedMessages(item);
      }
    } else {
      if (this.saveModel === "add") {
        this.deleteOneMessageFromSelectedMessages(item);
      } else if (this.saveModel === "delete") {
        this.addOneMessageToSelectedMessages(item);
      }
    }
    const checkedCount = this.countHowMuchCurrentPageMessagesSelected();
    this.checkAll = checkedCount === this.patients.length;
    this.isIndeterminate =
      checkedCount > 0 && checkedCount < this.patients.length;
  }
  /**
   * @description 某行被点击
   */
  private rowClicked(row, column, event) {
    this.$router.push({
      path: "/main/edr/patient-detail",
      query: {
        patient_id: row.patient_id,
        project_id: this.project.project_id,
        group_id: this.groupId,
      },
    });
  }
  private mounted() {
    this.fetchPatients().then(() => {
      this.fetchHospitals();
    });
  }
}
